import { microwaveQueries } from '@round/api';
import { useQuery } from '@tanstack/react-query';

const options = microwaveQueries.influencerAccounts.options.detail;
const utils = microwaveQueries.influencerAccounts.utils.detail;

type Config = Pick<ReturnType<typeof options>, 'enabled'>;

export default function useMicrowaveInfluencerAccount(
    id: number | null | undefined,
    config: Config = { enabled: true }
) {
    const query = useQuery({ ...options(id), ...config });
    return {
        data: query.data,
        isLoading: query.isLoading,
        error: query.error,
        errorMessage: utils.getErrorMessage(query.error),
    };
}
